import { useEffect, useRef } from 'react'
import { useTheme } from '../context/ThemeContext'

// LinkedIn's official Profile Badge widget. Loaded lazily (not in index.html)
// since it's only used here, inside Recruiter Toolkit. The badge is a static
// snapshot LinkedIn renders into an iframe on parse — it doesn't react to
// theme changes on its own, so we remount the div (via `key`) and call
// window.IN.parse() again whenever the site theme flips.
const SCRIPT_SRC = 'https://platform.linkedin.com/badges/js/profile.js'

function loadScript() {
  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
    if (existing) {
      if (window.IN) resolve()
      else existing.addEventListener('load', () => resolve())
      return
    }
    const script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    document.body.appendChild(script)
  })
}

export default function LinkedInBadge() {
  const { theme } = useTheme()
  const containerRef = useRef(null)

  useEffect(() => {
    let cancelled = false
    loadScript().then(() => {
      if (cancelled) return
      // IN.parse() scans the DOM for badge markup and (re)renders it —
      // needed both on first load and whenever `theme` changes the markup.
      if (window.IN && window.IN.parse) {
        window.IN.parse(containerRef.current)
      }
    })
    return () => {
      cancelled = true
    }
  }, [theme])

  return (
    <div ref={containerRef} key={theme}>
      <div
        className="badge-base LI-profile-badge"
        data-locale="en_US"
        data-size="medium"
        data-theme={theme === 'light' ? 'light' : 'dark'}
        data-type="HORIZONTAL"
        data-vanity="daddydreams"
        data-version="v1"
      >
        <a
          className="badge-base__link LI-simple-link"
          href="https://ng.linkedin.com/in/daddydreams?trk=profile-badge"
        >
          Dreams Adebomi
        </a>
      </div>
    </div>
  )
}
